import generateUid from '@src/utils/generate-uid';
let deviceId;
const localDeviceId = localStorage.getItem('LOCAL_STORAGE_DEVICE_ID');

const operateFrom = 'pc'; // pc | h5

const entrance = 'pc'; // pc | h5 | official(小程序)

// 先查询本地缓存，没有再生成
if (localDeviceId) {
  deviceId = localDeviceId;
} else {
  deviceId = generateUid();
  localStorage.setItem('LOCAL_STORAGE_DEVICE_ID', deviceId);
}

function getUaOs() {
  const userAgent = navigator.userAgent;
  let os = 'Unknown';

  if (/android/i.test(userAgent)) {
    os = 'Android';
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    os = 'iOS';
  } else if (/harmony/i.test(userAgent)) {
    os = '鸿蒙';
  } else if (/Windows NT/i.test(userAgent)) {
    os = 'Windows';
  } else if (/Macintosh/i.test(userAgent)) {
    os = 'Mac';
  }
  return os;
}

function getParameterByNames(name, url) {
  // eslint-disable-next-line no-undef
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getUtmSource() {
  return getParameterByNames('utm_source');
}

export { deviceId, getUaOs, getUtmSource, operateFrom, entrance, getParameterByNames };
